import { IServices } from "@netent/origin";
import { IAutoplaySetting, PlayUI, View } from "@netent/playui";
import { Store } from "redux";
import { IStoreAction, IStoreState } from "../store";
import { onAutoplayResetRequest } from "./onAutoplayResetRequest";
import { onAutoplaySelectRoundsChangeRequest } from "./onAutoplaySelectRoundsChangeRequest";
import { onAutoplaySettingChangeRequest } from "./onAutoplaySettingChangeRequest";
import { onBetDenominationChangeRequest } from "./onBetDenominationChangeRequest";
import { onBetLevelChangeRequest } from "./onBetLevelChangeRequest";
import { onGameHistoryRequest } from "./onGameHistoryRequest";
import { onGameRulesRequest } from "./onGameRulesRequest";
import { onHomeRequest } from "./onHomeRequest";
import { onMoneyTypeChangeRequest } from "./onMoneyTypeChangeRequest";
import { onMuteChangeRequest } from "./onMuteChangeRequest";
import { onPluginRequest } from "./onPluginRequest";
import { onQuickSpinChangeRequest } from "./onQuickSpinChangeRequest";
import { onSettingChangeRequest } from "./onSettingChangeRequest";
import { onSpinRequest } from "./onSpinRequest";
import { onTickerAnimationEnd } from "./onTickerAnimationEnd";
import { onViewChangeRequest } from "./onViewChangeRequest";
import { onVolumeChangeRequest } from "./onVolumeChangeRequest";

export const setupListeners = (
  services: IServices,
  store: Store<IStoreState, IStoreAction>,
  playui: PlayUI
): void => {
  playui.onSpinRequest = onSpinRequest(services, store);
  playui.onQuickSpinChangeRequest = onQuickSpinChangeRequest(services, store);
  playui.onSettingChangeRequest = onSettingChangeRequest(services, store);
  playui.onViewChangeRequest = (view: View) =>
    onViewChangeRequest(services, store)(view);
  playui.onBetDenominationChangeRequest = onBetDenominationChangeRequest(
    services,
    store
  );
  playui.onBetLevelChangeRequest = onBetLevelChangeRequest(services, store);
  playui.onVolumeChangeRequest = onVolumeChangeRequest(services, store);
  playui.onMuteChangeRequest = onMuteChangeRequest(services, store);
  playui.onAutoplaySelectRoundsChangeRequest = onAutoplaySelectRoundsChangeRequest(
    services,
    store
  );
  playui.onAutoplayResetRequest = onAutoplayResetRequest(services, store);
  playui.onAutoplaySettingChangeRequest = (updatedSetting: IAutoplaySetting) =>
    onAutoplaySettingChangeRequest(services, store)(updatedSetting);
  playui.onMoneyTypeChangeRequest = type =>
    onMoneyTypeChangeRequest(services, store)(type);
  playui.onTickerAnimationEnd = onTickerAnimationEnd(services, store);
  playui.onGameHistoryRequest = onGameHistoryRequest(services, store);
  playui.onGameRulesRequest = onGameRulesRequest(services, store);
  playui.onHomeRequest = onHomeRequest(services, store);
  playui.onPluginRequest = onPluginRequest(services, store);
};
